import { useCallback, useMemo } from "react";
import { liveConnectorIdsBySpace } from "../../shared/liveConnectorUsage";
import { queries } from "../../shared/queries";
import { usedConnectorsForSpace } from "../lib/usedSuppliersForSpace";
import { useQuery } from "./useQuery";

// Resolves the connectors a space uses (run by a live branch head + git remote)
// on the client, mirroring the server's spaceAppEdgesZql. The connector rows
// already carry their git-remote `.usages`; the live step usage comes from here.
// Only spaces in `spaceIds` resolve, so pass every space that will be asked for.
export function useSpaceUsedSuppliers<
  T extends { id: string; usages?: readonly { type: string; refId: string }[] },
>(connectors: readonly T[], spaceIds: readonly string[]) {
  const [workflows] = useQuery(
    queries.liveConnectorUsageBySpace({ spaceIds: [...spaceIds] })
  );
  const liveAppIdsBySpace = useMemo(
    () => liveConnectorIdsBySpace(workflows),
    [workflows]
  );
  const usedConnectors = useCallback(
    (spaceId: string) =>
      usedConnectorsForSpace(spaceId, connectors, liveAppIdsBySpace),
    [connectors, liveAppIdsBySpace]
  );
  return { usedConnectorsForSpace: usedConnectors };
}
